import request from '@/utils/request'

export function getConfigList() {
  return request({
    url: '/admin/config/list',
    method: 'get'
  })
}

export function createConfig(data) {
  return request({
    url: '/admin/config',
    method: 'post',
    data
  })
}

export function updateConfig(configKey, data) {
  return request({
    url: '/admin/config/' + configKey,
    method: 'put',
    data
  })
}

export function deleteConfig(configKey) {
  return request({
    url: '/admin/config/' + configKey,
    method: 'delete'
  })
}
